import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AddPayoutFailure.css';
import bt from '../../../src/components/commonStyle.css';

// Components
import history from '../../core/history';

// Locale
import messages from '../../locale/jsonMessages';

const AddPayoutFailure = (props) => {

  const handleClick = () => {
    history.push('/user/addpayout');
  }

  return (
    <div className={s.container}>
      <Grid fluid>
        <Row className={cx(s.space8, s.spaceTop8)}>
          <Col xs={12} sm={12} md={12} lg={12} className={s.textCenter}>
            <h1 className={cx(s.textJumbo, 'hidden-xs', 'hidden-sm')}>
              <FormattedMessage {...messages.payoutFailure} />
            </h1>
            <h1 className={cx(s.textMedium, 'visible-xs', 'visible-sm')}>
              <FormattedMessage {...messages.payoutFailure} />
            </h1>
            <h2><FormattedMessage {...messages.payoutFailureSubtitle} /></h2>
            <p className={s.marginTop20}><FormattedMessage {...messages.payoutFailureContent} /></p>
            <Col xs={12} sm={12} md={12} lg={12} className={s.marginTop20}>
              <Button
                className={cx(bt.btnPrimaryBorder, s.firstBtn)}
                onClick={() => handleClick()}
              >
                <FormattedMessage {...messages.payoutRetry} />
              </Button>
              <Button
                className={cx(bt.btnPrimary)}
                onClick={() => handleClick()}
              >
                <FormattedMessage {...messages.addPayout} />
              </Button>
            </Col>
          </Col>
        </Row>
      </Grid>
    </div>
  );
}

AddPayoutFailure.propTypes = {
  title: PropTypes.string.isRequired,
  formatMessage: PropTypes.func,
};

export default withStyles(s, bt)(AddPayoutFailure);
